import axios from "axios"
import base_url from "@/api/config";

const fosasApi = axios.create({
    baseURL: base_url+'/web/data'        
});

export default fosasApi; 